export function Card({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  return <div className={`bg-white rounded-xl shadow-md ${className}`}>{children}</div>;
}

export function CardContent({ className = "", children }: { className?: string, children: React.ReactNode }) {
  return <div className={`p-4 ${className}`}>{children}</div>;
}
